/**
 * The few ARM facts every Azure template here shares.
 *
 * Written as TypeScript values and not Bicep, for the reason the CloudFormation
 * templates are: the customer deploys the JSON this produces, a golden fixture
 * pins it, and a test can read any property without parsing a second language.
 * Bicep would be one more compiler between what we review and what they run.
 */
/** A deployment into one resource group: the runner. */
export const RESOURCE_GROUP_SCHEMA = 'https://schema.management.azure.com/schemas/2019-04-01/deploymentTemplate.json#';
/** A deployment into a subscription: an instance, which creates its own group. */
export const SUBSCRIPTION_SCHEMA = 'https://schema.management.azure.com/schemas/2018-05-01/subscriptionDeploymentTemplate.json#';
/**
 * Built-in role definitions, by id.
 *
 * Ids rather than names because a role assignment names its definition by id,
 * and the ids are the same in every tenant. Each is listed with what it is for,
 * since a role on this list is a right in someone else's tenant.
 */
export const BUILT_IN_ROLES = {
    /** The deploy app, on an instance's own group: everything but access control. */
    contributor: 'b24988ac-6180-42a0-ab88-20f7382dd24c',
    /** The dispatcher, on the runner's Key Vault: the deploy secret's expiry, never its value. */
    reader: 'acdd72a7-3385-48ef-bd42-f606fba81ae7',
    /** The runner identity, on its Key Vault: the deploy secret and the registry token. */
    keyVaultSecretsUser: '4633458b-17de-408a-b874-0445c86b69e6',
    /** The deploy app, on an instance's group: state over Entra, and the installer's destroy. */
    storageBlobDataContributor: 'ba92f5b4-2d11-453d-a403-e96b0029c9fe',
    /** Assigned by the installer to AKS on its subnet. */
    networkContributor: '4d97b98b-1d4f-4787-a291-c67834d212e7',
    /** The deploy app, on an instance's group, held to `ASSIGNABLE_BY_INSTALLER`. */
    roleBasedAccessControlAdministrator: 'f58310d9-a9f6-439a-9e8d-f62e7b41a168',
};
/** A built-in role's full id, as a role assignment names it. */
export const builtInRole = (id) => `[subscriptionResourceId('Microsoft.Authorization/roleDefinitions', '${id}')]`;
/** Tags every resource carries, so a reader finds them by what they publish (IM-115). */
export const qrveyTags = (artifact, version) => ({
    'qrvey-artifact': artifact,
    'qrvey-version': version,
});
//# sourceMappingURL=arm.js.map